/* ============================================================
   SINGSPACE ADMIN - SECTION NOTIFICATIONS PARAMÈTRES (Pro Max)
   ============================================================ */

import { useState } from 'react';
import { Mail, BellRing } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { FieldGroup } from './FieldGroup';
import { ToggleSwitch } from './ToggleSwitch';
import { Input } from '@/components/ui/input';

export function NotificationsSection() {
  const [toggles, setToggles] = useState({
    booking: true,
    quote: true,
    application: true,
    payment: true,
    reminder: false,
    quota: false,
  });

  const set = (key: keyof typeof toggles) => (v: boolean) => setToggles((p) => ({ ...p, [key]: v }));

  return (
    <div className="space-y-2 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SectionTitle
        label="Configuration des Alertes"
        description="Gérez les destinataires et les types d'événements qui déclenchent des notifications automatiques vers votre équipe."
      />

      <div className="bg-white rounded-[32px] border border-gray-50 p-2">
        <FieldGroup 
          label="Email de centralisation" 
          hint="Cette adresse recevra l'intégralité des alertes et copies de factures."
        >
          <Input
            type="email"
            leftIcon={<Mail size={18} />}
            defaultValue="reservations@sing.ga"
            className="max-w-lg h-14"
          />
        </FieldGroup>

        <div className="p-8">
          <div className="flex items-center gap-3 mb-8 px-1">
            <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center text-[#dfc32f]">
              <BellRing size={16} />
            </div>
            <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-[#00303c]">Événements déclencheurs d'alertes</h3>
          </div>

          <div className="space-y-2">
            <ToggleSwitch
              checked={toggles.booking}
              onChange={set('booking')}
              label="Nouvelle réservation coworking"
              description="Alerte immédiate pour chaque validation de bureau ou salle."
            />
            <ToggleSwitch
              checked={toggles.quote}
              onChange={set('quote')}
              label="Demande de devis entrante"
              description="Notification lors de la soumission d'une demande complexe."
            />
            <ToggleSwitch
              checked={toggles.application}
              onChange={set('application')}
              label="Candidature bureau permanent"
              description="Alerte à réception d'un nouveau dossier résident."
            />
            <ToggleSwitch
              checked={toggles.payment}
              onChange={set('payment')}
              label="Succès du paiement (SINGPAY)"
              description="Confirmation automatique après traitement bancaire réussi."
            />
            <ToggleSwitch
              checked={toggles.reminder}
              onChange={set('reminder')}
              label="Rappels automatiques J-1"
              description="Envoi d'un email de courtoisie aux clients 24h avant l'accès."
            />
            <ToggleSwitch
              checked={toggles.quota}
              onChange={set('quota')}
              label="Alerte de saturation (90%)"
              description="Notification préventive quand un espace est presque complet."
            />
          </div>
        </div>
      </div>
    </div>
  );
}
